/**
 * Saves data to sessionStorage with the specified key
 * @param key - The key to store the data under
 * @param value - The value to store
 */
export function setSessionStorageItem<T>(key: string, value: T) {
  try {
    const serializedValue = JSON.stringify(value);
    sessionStorage.setItem(key, serializedValue);
  } catch (error) {
    // NOTE: Handle error for browser that doesn't support sessionStorage
    console.error(`Error saving to sessionStorage: ${error}`);
  }
}

/**
 * Retrieves data from sessionStorage for the specified key
 * @param key - The key to retrieve data for
 * @param defaultValue - Optional default value to return if key doesn't exist
 * @returns The stored value or defaultValue if not found
 */
export function getSessionStorageItem<T>(key: string, defaultValue?: T) {
  try {
    const item = sessionStorage.getItem(key);
    if (item === null) {
      return defaultValue ?? null;
    }
    return JSON.parse(item) as T;
  } catch (error) {
    // NOTE: Handle error for browser that doesn't support sessionStorage
    console.error(`Error retrieving from sessionStorage: ${error}`);
    return defaultValue ?? null;
  }
}
